<div
  class="nav"
  [ngClass]="{ horizontal: layout === 'horizontal', vertical: layout === 'vertical' }"
>
  @if (layout === 'vertical') {
    @for (favopages of page; track favopages; let i = $index) {
      <span>
        @if (favopages.type === 'item') {
          <fuse-nav-vertical-item
            (onChangeVal)="onChange($event)"
            [item]="favopages"
            [itemIndex]="i"
          ></fuse-nav-vertical-item>
        }
      </span>
    }
    <div class="asidebottom-block">
      <mat-slide-toggle
        [(ngModel)]="EDITFavourite"
        name="EDITFavourite"
        (change)="ToggleForUpadteFavourite('')"
      >
        Edit Favourites
      </mat-slide-toggle>
    </div>
  }
</div>
